<ng-container>
  <wc-grid #grid gridKey="dashboardAccess" />
</ng-container>
